<script lang="ts">
  export let bankPromotionDetails;
</script>

{#if bankPromotionDetails}
  <div class="bank-promotion-container">
    {#each bankPromotionDetails as bankPromotionDetail}
      {#if bankPromotionDetail.bankHtmlMessage}
        {@html bankPromotionDetail.bankHtmlMessage}
      {/if}
    {/each}
  </div>
{/if}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .bank-promotion-container {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    // background-color: $primary-white;
    padding: 8px;
    border-radius: 8px;
    flex-direction: column;

    :global {
      * {
        padding: 0;
        margin: 0;
        font-size: 14px;
        line-height: 16px;
      }
    }
  }
</style>
